import React from 'react';
import config from 'config/config';
import GenericFaq from '../../../common/faqs/generic-faq';

const LiveBlogFAQ = () => {
  return (
    <GenericFaq>
      <div className="faq">What is a live blog?</div>
      <div className="faq-description">
        Live blog present news as it happens! Live blog is an article updated by reporters as a
        story unfolds. Your readers see the update as soon as you post it, and they can then react
        to the development.
      </div>

      <div className="faq">Why have live blog?</div>
      <div className="faq-description">
        Live blog is an excellent way to deliver information quickly, and to keep readers interested
        and up-to-date. Start a live blog when compelling events are unfolding over time and you’ll
        see that your readers engage more with you.
      </div>

      <div className="faq">Who can post updates?</div>
      <div className="faq-description">
        Reporters post updates to the live blog. Assign reporters to the event on the Settings page.
      </div>

      <div className="faq">Still have questions?</div>
      <div className="faq-description">
        <span>
          Visit our
          <a className="faq-link" href={config.api.urls.support} target="_blank" rel="noreferrer">
            {' '}
            support{' '}
          </a>
          site or go ahead and
          <a className="faq-link" href={config.api.urls.contact} target="_blank" rel="noreferrer">
            {' '}
            contact{' '}
          </a>
          our support team.
        </span>
      </div>
    </GenericFaq>
  );
};

export default LiveBlogFAQ;
